import React from 'react';
import './Values.css';

const Values = () => {
  const values = [
    {
      id: 1,
      icon: "🤝",
      title: "Integrity First",
      description: "We communicate openly, quote fairly, and keep our promises every single time."
    },
    {
      id: 2,
      icon: "🛡️",
      title: "Safety Always",
      description: "Your safety is our priority. Every installation meets the highest safety standards."
    },
    {
      id: 3,
      icon: "💡",
      title: "Innovation Driven",
      description: "We embrace modern technology to deliver cutting-edge electrical solutions."
    },
    {
      id: 4,
      icon: "👥",
      title: "Client First",
      description: "We listen and tailor every solution to your specific needs and requirements."
    }
  ];

  return (
    <section className="values-section">
      <div className="values-container">
        {/* Section Header */}
        <div className="values-header">
          <h4 className="values-subtitle">Values</h4>
          <h1 className="values-title">Exceptional Service. Powered by Expertise.</h1>
          <p className="values-description">
            At Musa Electrical, we do more than just fix wires — we bring safety, reliability, 
            and peace of mind to every home and business we serve.
          </p>
        </div>

        {/* Values Grid */}
        <div className="values-grid">
          {values.map((value) => (
            <div className="value-card" key={value.id}>
              <div className="value-icon-circle">
                <span className="value-icon">{value.icon}</span>
              </div>
              <h3>{value.title}</h3>
              <p>{value.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Values;
